type CASHFLOW = 'FIXED' | 'VARIABLE';

export interface INPV_FORMULA {
  initialInvestment: number | undefined;
  cashFlowPerAnnum: number | undefined;
  discountRate: number | undefined;
  investmentTenure: number | undefined;
  cashFlowType: CASHFLOW;
  firstYearCashFlow: number;
  secondYearCashFlow: number;
  thirdYearCashFlow: number;
  fourthYearCashFlow: number;
  fifthYearCashFlow: number;
}

export const NPV_FORMULA = ({
  initialInvestment,
  cashFlowPerAnnum,
  discountRate,
  investmentTenure,
  cashFlowType,
  firstYearCashFlow,
  secondYearCashFlow,
  thirdYearCashFlow,
  fourthYearCashFlow,
  fifthYearCashFlow,
}: INPV_FORMULA) => {
  if (
    !initialInvestment ||
    initialInvestment < 0 ||
    !discountRate ||
    !investmentTenure ||
    !cashFlowType ||
    (cashFlowType === 'FIXED' && (!cashFlowPerAnnum || cashFlowPerAnnum < 0)) ||
    (cashFlowType === 'VARIABLE' &&
      (firstYearCashFlow < 0 ||
        secondYearCashFlow < 0 ||
        thirdYearCashFlow < 0 ||
        fourthYearCashFlow < 0 ||
        fifthYearCashFlow < 0))
  ) {
    return {
      npv: 0,
      pvci: 0,
    };
  }

  let pvci = 0;
  let npv = 0;
  if (cashFlowType === 'FIXED' && cashFlowPerAnnum) {
    for (let year = 1; year <= investmentTenure; year++) {
      pvci += cashFlowPerAnnum / Math.pow(1 + discountRate / 100, year);
    }
    npv = pvci - initialInvestment;
  } else if (cashFlowType === 'VARIABLE') {
    const cashFlows = [
      firstYearCashFlow,
      secondYearCashFlow,
      thirdYearCashFlow,
      fourthYearCashFlow,
      fifthYearCashFlow,
    ];

    for (let year = 1; year <= 5; year++) {
      // Use bracket notation to access object properties dynamically
      const cashFlowForYear = cashFlows[year - 1] ?? 0; // Use nullish coalescing to default to 0 if undefined
      if (cashFlowForYear) {
        pvci += cashFlowForYear / Math.pow(1 + discountRate / 100, year);
      }
    }
    npv = pvci - initialInvestment;
  }

  return {
    npv: npv,
    pvci: pvci,
  };
};
